// extracted by mini-css-extract-plugin
module.exports = {"Input":"classes_Input__2cuFK","CheckboxButton":"classes_CheckboxButton__Sjkco","buttonCheckBox":"classes_buttonCheckBox__34aUC"};